import { useRecoilValue } from "recoil";
import payloadState from "../../recoil/payloadState";

export default function BottomSection() {
  const payload = useRecoilValue(payloadState);

  // Function to get the default logo based on domain
  const getDefaultLogo = () => {
    if (typeof window !== "undefined" && window.location) {
      const origin = window.location.origin;

      if (origin.endsWith("lipad.io")) {
        return "https://lipad-storage.fra1.cdn.digitaloceanspaces.com/static-assets/lipad-logo-blue-powered-by.svg";
      } else if (origin.endsWith("kasapay.com")) {
        return "https://fra1.digitaloceanspaces.com/lipad-storage/uploads/62541b5b-a6e7-456b-99c7-8d2227675a36-Kasapay_logo_blue.png";
      }
    }

    // Default fallback to lipad logo
    return "/assets/broken-link.png";
  };

  return (
    <div className="mb-4 flex w-full justify-center ">
      <img
        className="h-12 w-24 object-contain"
        src={
          payload?.client_data.checkout_configs.branding_configs.logo ??
          getDefaultLogo()
        }
        alt=""
      />
    </div>
  );
}
